import { ESchema } from "@/components/table/filter/tableEnums";

 export const entityTypes = [
    { id: ESchema.ACTIVITIES, name: "Atividade" },
    { id: ESchema.MEASUREMENTS, name: "Medição" },
    { id: ESchema.MAINTENANCES, name: "Manutenção" },
    { id: ESchema.ACCESS_REQUESTS, name: "Acesso" },
  ]